var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyllabusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "144px",
    viewBox: "0 0 120 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VECTOR - Syllabus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VECTOR---Syllabus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74,109 C63,118 61,124 52,119 C44.1731831,114.651768 43.9327607,108.183834 51,102 C59,95 68,81 66,74 C64,67 51,65 42,60 C20.8867845,48.2704358 45,21 70.4399855,26.649993 C95.879971,32.2999861 96,51 98,65 C89.3333333,88.3333333 81.3333333,103 74,109 Z",
    id: "Blob",
    fill: "#FEF6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sparks",
    transform: "translate(21.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(0.000000, 28.000000)",
    fill: "#F7A600"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(60.000000, 0.000000)",
    fill: "#F9D076"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(57.000000, 82.000000)",
    fill: "#F9D076"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Syllabus",
    transform: "translate(43.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeLinecap: "square",
    x: 19.2631579,
    y: 4.85714286,
    width: 34,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6167255,12.3 L27.3914508,12.3 C26.5986794,12.3 25.9560112,11.8410919 25.9560112,11.275 C25.9560112,10.7089081 26.5986794,10.25 27.3914508,10.25 L44.6167255,10.25 C45.4094969,10.25 46.052165,10.7089081 46.052165,11.275 C46.052165,11.8410919 45.4094969,12.3 44.6167255,12.3 Z",
    id: "Path",
    fill: "#C80000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.174952,17.425 L34.6483952,17.425 C34.1639238,17.425 33.7711821,16.9660919 33.7711821,16.4 C33.7711821,15.8339081 34.1639238,15.375 34.6483952,15.375 L45.174952,15.375 C45.6594234,15.375 46.052165,15.8339081 46.052165,16.4 C46.052165,16.9660919 45.6594234,17.425 45.174952,17.425 Z",
    id: "Path",
    fill: "#C80000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86230291,38.95 L14.8678302,38.95 L14.8678302,27.27525 C14.8683269,26.8729295 15.0985287,26.5081088 15.4564207,26.3424598 C15.8143127,26.1768107 16.2337071,26.2409679 16.5287477,26.5065 L18.9801019,28.7 L26.0640152,22.0375 C26.1644348,21.9508084 26.2229045,21.8235245 26.2241036,21.689 C26.2395196,21.5519231 26.1913817,21.4153609 26.0940318,21.32 C26.0032483,21.2209058 25.8764975,21.1646934 25.7438383,21.1646934 C25.6111791,21.1646934 25.4844283,21.2209058 25.3936448,21.32 L20.6009973,25.81975 C20.4048735,26.0029513 20.1457311,26.098817 19.8805993,26.08625 C19.6122853,26.0743638 19.3599001,25.952475 19.1802124,25.748 L15.4281397,21.525 L4.62217026,21.525 L2.20083266,30.176 L4.20193811,31.0985 L4.33200997,31.16 L9.0446133,33.32275 C9.25021259,33.4157493 9.48929848,33.3833128 9.66417987,33.2386941 C9.83906127,33.0940755 9.92044291,32.8615006 9.87507207,32.636 C9.84177281,32.4734334 9.74860329,32.3302644 9.61492836,32.23625 L5.47264007,29.57125 C5.16879647,29.3771655 4.98910667,29.0317647 5.00125808,28.6651567 C5.01340949,28.2985487 5.21555602,27.9664301 5.53155102,27.7939067 C5.84754603,27.6213833 6.22938236,27.6346655 6.53322596,27.82875 L10.6755142,30.504 C11.8232512,31.2531784 12.2133624,32.7819756 11.5703408,34.0107143 C10.9273192,35.239453 9.46850869,35.7528149 8.22416007,35.18825 L4.86230291,33.65075 L4.86230291,38.95 Z",
    id: "Shape-Copy-2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8683829,41 L3.86175019,41 C3.30916017,41 2.86119746,40.5410919 2.86119746,39.975 L2.86119746,32.72825 L0.589942772,31.70325 C0.135659779,31.4937226 -0.0989390047,30.9737338 0.0396387726,30.4835 L2.9112251,20.2335 C3.03960215,19.7812095 3.452353,19.4767676 3.91177782,19.4955 L15.9184105,19.4955 C16.2007447,19.4961836 16.4696559,19.6190336 16.6588195,19.83375 L19.9806546,23.575 L23.9828655,19.762 C25.0053475,18.8107912 26.5845524,18.8793416 27.5248221,19.91575 C28.4836434,20.9527557 28.4433821,22.5888053 27.4347724,23.575 L19.6904943,30.8525 C19.3096648,31.2046065 18.7305831,31.2046065 18.3497537,30.8525 L16.8689356,29.52 L16.8689356,39.975 C16.8689356,40.5410919 16.4209729,41 15.8683829,41 Z M4.86230291,38.95 L14.8678302,38.95 L14.8678302,27.27525 C14.8683269,26.8729295 15.0985287,26.5081088 15.4564207,26.3424598 C15.8143127,26.1768107 16.2337071,26.2409679 16.5287477,26.5065 L18.9801019,28.7 L26.0640152,22.0375 C26.1644348,21.9508084 26.2229045,21.8235245 26.2241036,21.689 C26.2395196,21.5519231 26.1913817,21.4153609 26.0940318,21.32 C26.0032483,21.2209058 25.8764975,21.1646934 25.7438383,21.1646934 C25.6111791,21.1646934 25.4844283,21.2209058 25.3936448,21.32 L20.6009973,25.81975 C20.4048735,26.0029513 20.1457311,26.098817 19.8805993,26.08625 C19.6122853,26.0743638 19.3599001,25.952475 19.1802124,25.748 L15.4281397,21.525 L4.62217026,21.525 L2.20083266,30.176 L4.20193811,31.0985 L4.33200997,31.16 L9.0446133,33.32275 C9.25021259,33.4157493 9.48929848,33.3833128 9.66417987,33.2386941 C9.83906127,33.0940755 9.92044291,32.8615006 9.87507207,32.636 C9.84177281,32.4734334 9.74860329,32.3302644 9.61492836,32.23625 L5.47264007,29.57125 C5.16879647,29.3771655 4.98910667,29.0317647 5.00125808,28.6651567 C5.01340949,28.2985487 5.21555602,27.9664301 5.53155102,27.7939067 C5.84754603,27.6213833 6.22938236,27.6346655 6.53322596,27.82875 L10.6755142,30.504 C11.8232512,31.2531784 12.2133624,32.7819756 11.5703408,34.0107143 C10.9273192,35.239453 9.46850869,35.7528149 8.22416007,35.18825 L4.86230291,33.65075 L4.86230291,38.95 Z",
    id: "Shape",
    fill: "#38627F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86506654,19.475 C6.54952647,19.475 3.86175019,16.7215512 3.86175019,13.325 C3.86175019,9.92844879 6.54952647,7.175 9.86506654,7.175 C13.1806066,7.175 15.8683829,9.92844879 15.8683829,13.325 C15.8683829,16.7215512 13.1806066,19.475 9.86506654,19.475 L9.86506654,19.475 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86506654,19.475 C6.54952647,19.475 3.86175019,16.7215512 3.86175019,13.325 C3.86175019,9.92844879 6.54952647,7.175 9.86506654,7.175 C13.1806066,7.175 15.8683829,9.92844879 15.8683829,13.325 C15.8683829,16.7215512 13.1806066,19.475 9.86506654,19.475 L9.86506654,19.475 Z M9.86506654,9.225 C7.65470649,9.225 5.86285564,11.0606325 5.86285564,13.325 C5.86285564,15.5893675 7.65470649,17.425 9.86506654,17.425 C12.0754266,17.425 13.8672774,15.5893675 13.8672774,13.325 C13.8672774,11.0606325 12.0754266,9.225 9.86506654,9.225 Z",
    id: "Shape-Copy-7",
    fill: "#38627F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8BC2D",
    x: 18.8157895,
    y: 1.46428571,
    width: 34.7368421,
    height: 4.39285714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9994473,6.15 L17.9795491,6.15 C17.4269591,6.15 16.9789964,5.69109187 16.9789964,5.125 L16.9789964,1.025 C16.9789964,0.458908131 17.4269591,0 17.9795491,0 L53.9994473,0 C54.5520373,0 55,0.458908131 55,1.025 L55,5.125 C55,5.69109187 54.5520373,6.15 53.9994473,6.15 Z M18.9801019,4.1 L52.9988945,4.1 L52.9988945,2.05 L18.9801019,2.05 L18.9801019,4.1 Z",
    id: "Shape",
    fill: "#38627F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9983418,27.388 C51.4457518,27.388 50.9977891,26.9290919 50.9977891,26.363 L50.9977891,6.15 L20.9812073,6.15 L20.9812073,19.03425 C20.9812073,19.6003419 20.5332446,20.05925 19.9806546,20.05925 C19.4280646,20.05925 18.9801019,19.6003419 18.9801019,19.03425 L18.9801019,5.125 C18.9801019,4.55890813 19.4280646,4.1 19.9806546,4.1 L51.9983418,4.1 C52.5509318,4.1 52.9988945,4.55890813 52.9988945,5.125 L52.9988945,26.363 C52.9988945,26.9290919 52.5509318,27.388 51.9983418,27.388 Z",
    id: "Path",
    fill: "#38627F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.0287417,
    y1: 26.65,
    x2: 29.016029,
    y2: 26.65,
    id: "Line-2",
    stroke: "#38627F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabusIcon);
export default __webpack_public_path__ + "static/media/syllabusIcon.cb1d3f5b09e6cc8d5c8e80cb32254bb5.svg";
export { ForwardRef as ReactComponent };